import { ApolloLink } from 'apollo-link';

const headersLink = new ApolloLink((operation, forward) => {
  operation.setContext({
    headers: {
      'x-sah-operation-name': operation.operationName
    }
  });
  return forward(operation);
});

export default headersLink;
